module.exports = __webpack_public_path__ + "img/training_mix2.9d1ef34c.jpg";